export interface SendbirdWidgetProps {
  onClose?: () => void;
  openSupportChat?: () => void;
  track?: (event: SendbirdTrackingEvent) => void;
}

export type SendbirdChatContext = {
  srQuotaUsagePercent?: string;
  srMobileFeatureFlag?: string;
  idManagementVersion?: string;
  userProjectRole?: string;
  userOrganizationRole?: string;
  featureGateName?: string;
  packages?: string;
  canModifyPlanOnline?: string;
  accountManager?: string;
  userFirstName?: string;
  projectId?: string;
  organizationId?: string;
  currentURL?: string;
  viewId?: string;
  warehouseSyncStatus?: string;
  userEmail?: string;
  isMTUPlan?: string;
  srProvisioned?: string;
};

export type SendbirdTokenResponse = {
  status: string;
  token?: string;
  expires_at?: string;
  application_id?: string;
  ai_agent_id?: string;
  type?: string;
  error?: string;
  code?: number;
  message?: string;
};

export type SendbirdCreateUserResponse = {
  status: string;
  user_id?: string;
  is_created?: boolean;
  type?: string;
  error?: string;
  code?: number;
  message?: string;
};

export enum SendbirdTrackingEvent {
  ChatOpened = `Chat Opened`,
  ChatClosed = `Chat Closed`,
  ChatFailed = `Chat Failed`,
  ChatContextLoaded = `Chat Context Loaded`,
  ChatAsyncContextLoaded = `Chat Async Context Loaded`,
  ChatMinimized = `Chat Minimized`,
  ChatUnMinimized = `Chat UnMinimized`,
  ChatExpanded = `Chat Expanded`,
  ChatReduced = `Chat Reduced`,
}

export const DefaultApiErrorResponse = {error: `true`, message: `internal error`, code: 500};

export const SendbirdLocalStorageTTL = 1000 * 60 * 10; //10 minutes. We only want chat to reopen when navigating or refreshing the page
